import { useTranslation } from "@/i18n/client";
import { ContextModalProps } from "@mantine/modals";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import React, { ReactNode } from "react";

interface SomethingWentWrongProps {
  title?: string;
  description?: ReactNode;
  closeLabel?: string;
  reset?: () => void;
}

export const somethingWentWrongModalContext = {
  modal: "somethingWentWrong",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const SomethingWentWrong = ({ context, id, innerProps }: ContextModalProps<SomethingWentWrongProps>) => {
  const { t } = useTranslation("common");
  const { title, description, closeLabel, reset } = innerProps;

  return (
    <Box pos="relative">
      <Modal.Title>{title ?? t("somethingWentWrong")}</Modal.Title>
      <Modal.Description description={description ?? t("somethingWentWrongDescription")} />
      <ButtonsGroup
        rightButtonText={closeLabel ?? t("tryAgain")}
        onRightButtonClick={() => (reset ? reset() : context.closeModal(id))}
        withLeftButton={false}
      />
    </Box>
  );
};
